export default __webpack_public_path__ + "assets/images/10e8e95a646083e7b067ccf568edd1ff.png";